document.addEventListener('DOMContentLoaded', function () {
  // Main product handles that are allowed to "own" a warranty
  // 🔁 Adjust these handles if your product handles differ
  const SMART_HANDLES = [
    'smartslydr',
    'smart-pet-door',
    'smartslydr-regal-customized-smart-door-or-window-solution',
    'smartslydr-accessibility-hands-free-automatic-sliding-door-opener-for-wheelchair-users-seniors'
  ];

  // Warranty product handles
  // 🔁 Adjust to match your actual warranty product handles in Shopify
  const WARRANTY_HANDLES = [
    'smartslydr-extended-warranty-2-years-total',
    'smartslydr-extended-warranty-3-years-total'
  ];

  function removeOrphanWarranties() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;

        const hasSmart = cart.items.some(function (item) {
          return SMART_HANDLES.includes(item.handle);
        });

        // If at least one SmartSlydr-type product is still in cart, do nothing
        if (hasSmart) return;

        // Otherwise, remove all warranty items
        const warrantyItems = cart.items.filter(function (item) {
          return WARRANTY_HANDLES.includes(item.handle);
        });

        if (!warrantyItems.length) return;

        const removals = warrantyItems.map(function (item) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: item.key,   // line-item key from /cart.js
              quantity: 0
            })
          });
        });

        Promise.all(removals)
          .then(function () {
            // On the cart page, force UI refresh so the line disappears
            if (window.location.pathname === '/cart') {
              window.location.reload();
            } else {
              document.dispatchEvent(new CustomEvent('cart:warrantyRemoved'));
            }
          })
          .catch(function (err) {
            console.error('Error removing warranty items:', err);
          });
      })
      .catch(function (err) {
        console.error('Error reading cart for warranty cleanup:', err);
      });
  }

  // Run once when the cart page loads (after any full reload)
  removeOrphanWarranties();

  // Re-run around cart interactions

  document.addEventListener('change', function (evt) {
    const target = evt.target;
    if (target && target.matches('input[name="updates[]"]')) {
      setTimeout(removeOrphanWarranties, 800);
    }
  });

  document.addEventListener('click', function (evt) {
    const removeLink = evt.target.closest(
      'cart-remove-button a, a[href*="/cart/change"]'
    );
    const minusButton = evt.target.closest('.quantity__button[name="minus"]');

    if (removeLink || minusButton) {
      setTimeout(removeOrphanWarranties, 800);
    }
  });

  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evtName) {
    document.addEventListener(evtName, function () {
      setTimeout(removeOrphanWarranties, 400);
    });
  });

  const cartForm = document.querySelector('form#cart');
  if (cartForm) {
    cartForm.addEventListener('submit', function () {
      setTimeout(removeOrphanWarranties, 800);
    });
  }
});
